// extracted by mini-css-extract-plugin
export default {"AccordionGroup":"webpack-components-core-Accordion-components-AccordionGroup-module__AccordionGroup"};